import { env } from '../env';
import { EventCreateCommand, EventItem, EventUpdateCommand } from '../types/event';

const BASE_URL = env.apiUrl;

function authHeaders(accessToken: string): HeadersInit {
  return { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' };
}

export async function listEventsAdmin(accessToken: string): Promise<EventItem[]> {
  const res = await fetch(`${BASE_URL}/api/v1/events/admin`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load events');
  return res.json();
}

export async function getEvent(accessToken: string, eventGuid: string): Promise<EventItem> {
  const res = await fetch(`${BASE_URL}/api/v1/events/${eventGuid}`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load event');
  return res.json();
}

export async function createEvent(accessToken: string, cmd: EventCreateCommand): Promise<EventItem> {
  const res = await fetch(`${BASE_URL}/api/v1/events`, {
    method: 'POST',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to create event');
  return res.json();
}

export async function updateEvent(
  accessToken: string,
  eventGuid: string,
  cmd: EventUpdateCommand
): Promise<EventItem> {
  const res = await fetch(`${BASE_URL}/api/v1/events/${eventGuid}`, {
    method: 'PUT',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to update event');
  return res.json();
}

export async function deleteEvent(accessToken: string, eventGuid: string): Promise<void> {
  const res = await fetch(`${BASE_URL}/api/v1/events/${eventGuid}`, {
    method: 'DELETE',
    headers: authHeaders(accessToken),
  });
  if (!res.ok) throw new Error('Failed to delete event');
}
